import React from 'react';
import ProjectDetailRow from './ProjectDetailRow';
import { makeKey } from '@rd-web-markets/shared/dist/hooks/useConvertForTranslationKey';
import { useTranslation } from 'react-i18next';
import TopRowTitle from '../TopRowTitle';
const ProjectDetailsContractors = _ref => {
  let {
    projectDetails
  } = _ref;
  const {
    t
  } = useTranslation();
  const renderContractors = projectDetails.calculations.contractors_calculation.map(contractorsCalculation => {
    if (contractorsCalculation.errors) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Calculation for ", /*#__PURE__*/React.createElement("strong", null, contractorsCalculation.name), " has an error:"), /*#__PURE__*/React.createElement("p", null, contractorsCalculation.errors), /*#__PURE__*/React.createElement("br", null));
    }
    return ['dcr_remun_paid', 'dcr_remun_paid_not_in_20_26', 'dcr_remun_paid_in_20_26'].map((key, i) => {
      const label = `${t(key)} for ${contractorsCalculation.name}`;
      return /*#__PURE__*/React.createElement(ProjectDetailRow, {
        rowData: [key, contractorsCalculation[key]],
        label: i === 0 ? label : null,
        index: i + 'contractor',
        projectDetails: projectDetails,
        key: key + 'rowData',
        disabled: true,
        rowClass: i === 0 ? 'mt-3' : ''
      });
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(makeKey('Details of contract research (must be completed per contractor)'))
  }), renderContractors);
};
export default ProjectDetailsContractors;